var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero is-dark is-fullheight toc-grid"
  }, [_c('div', {
    staticClass: "container is-widescreen"
  }, [_c('div', {
    staticClass: "columns is-multiline is-mobile"
  }, _vm._l((_vm.chapters), function(chapter) {
    return _c('div', {
      staticClass: "column is-half-mobile is-one-third-tablet is-one-third-desktop"
    }, [_c('router-link', {
      attrs: {
        "to": '/chapter/' + chapter.id
      }
    }, [_c('TocItem', {
      attrs: {
        "chapter": chapter
      }
    })], 1)], 1)
  }))])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99bfb54e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toc.vue
// module id = sEP3
// module chunks = 0